export const allUserDetailResources_actionType = {
    ALL_USER_DETAIL_RESOURCES: 'ALL_USER_DETAIL_RESOURCES',
    ALL_USER_DETAIL_RESOURCES_SUCCESS: 'ALL_USER_DETAIL_RESOURCES_SUCCESS',
    ALL_USER_DETAIL_RESOURCES_ERROR: 'ALL_USER_DETAIL_RESOURCES_ERROR',
    RESET_ALL_USER_DETAIL_RESOURCES: 'RESET_ALL_USER_DETAIL_RESOURCES'
};